import axios from '@axios'

const group = 'salary_and_commission/'
const route = 'turno_programado'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    index(context, params) {
      return axios.post(group + route, params)
    },

    // carregar funcionarios
    carregarColaboradores(context) {
      return axios.get('helper/get_employees')
    },

    // salvar turno
    salvarTurno(context, turno) {
      return axios.post(`${group + route}/salvar_turno`, turno)
    },

    /**
     * salva os colaboradores selecionados
     */
    storeEmployeeSelected(context, employees) {
      return axios.post(`${group + route}/save_employee`, employees)
    },

    /**
     * remove os colaboradores selecionados
     */
    removeEmployeeSelected(context, employee_id) {
      return axios.post(`${group + route}/remove_employee`, { employee_id })
    },

    /**
     * remove  os turnos programados de um colaborador
     */
    removeScheduledShift(context, payload) {
      return axios.post(`${group + route}/remove_scheduled_shift`, payload)
    },

    removeOneScheduledShift(context, payload) {
      return axios.post(`${group + route}/remove_one_scheduled_shift`, payload)
    },

    /**
     * excluir um turno
     */
    excluirTurno(context, turno) {
      return axios.post(`${group + route}/delete_turno`, turno)
    },

    // turno regulares
    // salva turno regular
    saveShiftRegular(context, turno) {
      return axios.post(`${group + route}/save_shift_regular`, turno)
    },

    // carregar turno regular
    loadShiftRegular(context, employee_id) {
      return axios.get(`${group + route}/load_shift_regular/${employee_id}`)
    },

    // savar folga
    saveSlack(context, slack) {
      return axios.post(`${group + route}/save_slack`, slack)
    },

    // carregar falga
    loadEmployeeScheduleShift(context, params) {
      return axios.get(`${group + route}/load_employees_scheduled_shift`, params)
    },

  },

}
